module.exports = __webpack_public_path__ + "img/DK13538530.f5a7e8b9.png";